import Link from "@mui/material/Link";
import "./Footer.scss";

const Footer = () => {
  const today = new Date();
  const year = today.getFullYear();

  return (
    <footer
      /* Todo: move to own style file */
      style={{
        position: "relative",
        bottom: "0%",
        left: "0%",
      }}
    >
      <p>
        <Link href="/privacy-policy" underline="none" color="#333">
          <b>Privacy Policy </b>
        </Link>
        | Copyright (c) {year} Managed Solution LLC
      </p>
    </footer>
  );
};

export default Footer;
